import { useState } from 'react'

import { useSetState } from 'ahooks'
import { Button } from 'antd'

import { GenericalRecord } from '@eastcoal/common/types/utilities'
import { browserRedirect, setRedirectUrl } from '@eastcoal/common/utils/browser'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { Password } from '@eastcoal/formily/components/Password'
import { SchemaForm } from '@eastcoal/formily/components/SchemaForm'
import {
  SchemaFormProps,
  SchemaItem
} from '@eastcoal/formily/components/SchemaForm/interface'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { RouterLink } from '@eastcoal/router/components/Link'

import { LoginMfaModal } from '../Mfa'
import { useFormStyles } from '../style'

import { LoginPasswordProps } from './interface'

const schema: SchemaItem[] = [
  {
    type: 'string',
    name: 'username',
    'x-component': Input,
    'x-component-props': {
      placeholder: '账号'
    },
    'x-decorator': FormItem,
    'x-validator': {
      required: true,
      message: '请填写登录账号'
    }
  },
  {
    type: 'string',
    name: 'password',
    'x-component': Password,
    'x-component-props': {
      placeholder: '密码'
    },
    'x-decorator': FormItem,
    'x-validator': {
      required: true,
      message: '请填写登录密码'
    }
  }
]

const layout: SchemaFormProps<GenericalRecord>['layout'] = {
  labelAlign: 'left'
}

export const LoginPassword = ({
  passwordApi,
  mfaApi,
  ...restProps
}: LoginPasswordProps) => {
  const form = useCreationForm()
  const [mfaProps, setMfaProps] = useSetState({ open: false, user: {} })
  const [loading, setLoading] = useState(false)

  const handleSubmit = () => {
    form.submit(async values => {
      try {
        setLoading(true)
        const result = await passwordApi(values)
        if (result.user?.mfaEnabled) {
          // 需要二次验证
          setMfaProps({
            open: true,
            user: result.user
          })
        } else {
          browserRedirect()
        }
      } finally {
        setLoading(false)
      }
    })
  }

  const { styles } = useFormStyles()

  return (
    <>
      <SchemaForm
        {...restProps}
        className={styles.form}
        form={form}
        layout={layout}
        name='loginPasswordForm'
        schema={schema}
        grid={{
          columns: 1
        }}
        onSubmit={handleSubmit}
      >
        <div className={styles.forget}>
          <RouterLink to={setRedirectUrl('/password/reset')}>
            忘记密码
          </RouterLink>
        </div>
        <Button
          block
          className={styles.submitBtn}
          htmlType='submit'
          loading={loading}
          type='primary'
        >
          登录
        </Button>
      </SchemaForm>
      <LoginMfaModal
        {...mfaProps}
        api={mfaApi}
        onOpenChange={open => setMfaProps({ open })}
      />
    </>
  )
}
